// libs
import { styled } from '@nykaa/ui-components';

//components
import Timer from 'shared/components/Timer';

export const ExpiryContainer = styled.div<{ isOffer: boolean }>`
  background: rgba(253, 118, 133, 0.08);
  width: fit-content;
  ${({ theme }) => `padding: ${theme.spacing.spacing10} ${theme.spacing.spacing40}`};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const CountdownTimer = styled(Timer)`
  color: ${({ theme }) => theme.colors.secondary};
`;

export const CountdownTimerOver = styled.span`
  color: ${({ theme }) => theme.colors.secondary};
`;
